<template>
  <Navbar />
  <ScrollButton />

  <section
    class="banner-title"
    style="background-image: url(images/pcb-card-banner.jpg)"
  >
    <div class="auto-container">
      <div class="row clearfix text-center">
        <div class="title-column col-12">
          <h3 class="news-detail-title">{{ baslik }}</h3>
        </div>
      </div>
    </div>
  </section>

  <div class="container mt-5">
    <div class="row justify-content-center align-items-start">
      <div class="col-lg-6 mb-4">
        <div id="mySlide" class="carousel slide" data-bs-ride="carousel">
          <div class="carousel-indicators">
            <button type="button" data-bs-target="#mySlide" data-bs-slide-to="0" class="active"></button>
            <button type="button" data-bs-target="#mySlide" data-bs-slide-to="1"></button>
            <button type="button" data-bs-target="#mySlide" data-bs-slide-to="2"></button>
          </div>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img :src="resim1" class="d-block w-100" alt="slide-1" />
            </div>
            <div class="carousel-item">
              <img :src="resim2" class="d-block w-100" alt="slide-2" />
            </div>
            <div class="carousel-item">
              <img :src="resim3" class="d-block w-100" alt="slide-3" />
            </div>
          </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#mySlide" data-bs-slide="prev">
            <span class="carousel-control-prev-icon"></span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#mySlide" data-bs-slide="next">
            <span class="carousel-control-next-icon"></span>
          </button>
        </div>
      </div>

      <div class="col-lg-6">
        <h3 class="text-primary fw-bold">{{ baslik }}</h3>
        <p class="text-muted mb-1"><i class="bi bi-calendar3"></i> {{ tarih }}</p>
        <div v-html="icerik"></div>
      </div>
    </div>
  </div>

  <Footer />
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { doc, getDoc, getDocs, collection } from "firebase/firestore";
import moment from "moment";
import Navbar from "@/components/Navbar-2.vue";
import Footer from "@/components/Footer.vue";
import ScrollButton from "@/components/ScrollButton.vue";
import { firestore } from "@/firebase/config";
import { useHead } from '@vueuse/head';

const route = useRoute();
const hId = ref(route.params.newsId);
const baslik = ref("");
const icerik = ref("");
const resim1 = ref("");
const resim2 = ref("");
const resim3 = ref("");
const tarih = ref("");

moment.locale("tr");

onMounted(async () => {
  const docRef = doc(firestore, "haberler", hId.value);
  const docSnap = await getDoc(docRef);

  const detaySnapshot = await getDocs(collection(firestore, "haberler", hId.value, "haberDetay"));
  const detaylar = [];
  detaySnapshot.forEach(doc => detaylar.push({ ...doc.data(), id: doc.id }));

  if (docSnap.exists()) {
    const data = docSnap.data();
    baslik.value = data.baslik;
    tarih.value = moment(data.olusturulmaTarihi.toDate()).format("DD MMMM YYYY");

    if (detaylar.length > 0) {
      icerik.value = detaylar[0].icerik;
      resim1.value = detaylar[0].resim1;
      resim2.value = detaylar[0].resim2;
      resim3.value = detaylar[0].resim3;
    }
  }
});

useHead({
  title: () => `${baslik.value} - İntek Bilişim`,
  meta: [
    {
      name: 'description',
      content: () => `İntek Bilişim'e ait "${baslik.value}" başlıklı haberi okuyun.`
    },
    {
      property: 'og:title',
      content: () => `${baslik.value} - İntek Bilişim`
    },
    {
      property: 'og:image',
      content: () => resim1.value
    }
  ]
});
</script>

<style scoped>
.news-detail-title {
  color: #000;
  font-size: 30px;
  font-weight: 700;
}

.carousel-inner img {
  border-radius: 10px;
  max-height: 400px;
  object-fit: cover;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
}

@media (max-width: 767px) {
  .carousel-inner img {
    max-height: 250px;
  }

  .text-center {
    text-align: center !important;
  }

  .news-detail-title {
    font-size: 22px;
  }
}
</style>
